<div class="card card-chart">
	<div class="card-header card-header-{{ color }} card-header-icon">
		<div class="card-icon">
		  <i class="material-icons"></i>
		</div>
		<h4 class="card-title text-dark"> {{ charttitle }}</h4>
	</div>
	<div class="card-body">
		<div class="row m-0 p-0">
			
			<div class="col-md-10  m-0 p-0 ">
				<div class="container-fluid tp-box h-100 w-100" [@flipState]="flip">
					<div class="tp-box__side tp-box__back" [ngClass]="flip == 'inactive' ? 'd-none' : ''">
						<div class="table table-fluid" #print_items>
							<table class="table table-fixed table-hover">
								<thead>
									<tr>
										<th>{{ brandorpline }}</th>
										<th class="text-center">UNITS</th>
										<th class="text-right">NET</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let d of data">
										<td>{{ d.label }}</td>
										<td class="text-center">{{ d.qty }}</td>
										<td class="text-right">{{ d.total | currency }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div id="frontside" class="tp-box__side tp-box__front h-100 w-100" [ngClass]="flip == 'active' ? 'd-none' : ''">
						<canvas id="brandChart" class="ml-0 mr-auto table table-responsive h-100">{{chart}}</canvas>
					</div>
				</div>
			</div>
			<div class="col-md-2 filter-panel" [class.collapsed]="!showFilters">
			  <!-- Toggle Show/Hide Filters -->
			  <!-- <button mat-stroked-button color="primary" class="mb-3 w-100" (click)="showFilters = !showFilters">
				<mat-icon>{{ showFilters ? 'expand_less' : 'expand_more' }}</mat-icon>
				{{ showFilters ? 'Hide Filters' : 'Show Filters' }}
			  </button> -->
			
			  <div *ngIf="showFilters" class="m-0 p-0">
				<!-- Spinner or Load/Reset -->
				<div class="d-flex justify-content-between align-items-center mb-3">
				  <ng-container *ngIf="sending; else controls">
					<svg class="spinner" width="30" height="30" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					  <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				  </ng-container>
				  <ng-template #controls>
					<button mat-mini-fab color="accent" (click)="loadData()"><mat-icon>refresh</mat-icon></button>
					<button mat-button color="warn" (click)="reset()">Reset</button>
				  </ng-template>
				</div>
			
				<!-- Date Range -->
				<mat-form-field appearance="outline" class="w-100 mb-2">
				  <mat-label>Transaction Dates</mat-label>
				  <mat-date-range-input [rangePicker]="picker">
					<input matStartDate [formControl]="fromdateCtrl" placeholder="Start date">
					<input matEndDate [formControl]="todateCtrl" placeholder="End date">
				  </mat-date-range-input>
				  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				  <mat-date-range-picker #picker></mat-date-range-picker>
				</mat-form-field>
			
				<!-- Brand -->
				<mat-form-field appearance="outline" class="w-100 mb-2">
				  <mat-label>Brand</mat-label>
				  <mat-select [formControl]="brands" multiple appSelectAll>
					<mat-option *ngFor="let k of properties.brands" [value]="k.manufacturer_id">{{ k.name }}</mat-option>
				  </mat-select>
				</mat-form-field>
			
				<!-- Product Line -->
				<mat-form-field appearance="outline" class="w-100 mb-2">
				  <mat-label>Product Line</mat-label>
				  <mat-select [formControl]="lineid" multiple appSelectAll>
					<mat-option *ngFor="let k of properties.productlines" [value]="k.value">{{ k.name }}</mat-option>
				  </mat-select>
				</mat-form-field>
			
				<!-- Limit -->
				<mat-form-field appearance="outline" class="w-100 mb-2">
				  <mat-label>Limit</mat-label>
				  <mat-select [formControl]="limit">
					<mat-option *ngFor="let k of limits" [value]="k">{{ k }}</mat-option>
				  </mat-select>
				</mat-form-field>
			
				<!-- Location -->
				<mat-form-field *ngIf="locations?.length > 1" appearance="outline" class="w-100 mb-2">
				  <mat-label>Warehouse</mat-label>
				  <mat-select [formControl]="defaultlocation" multiple appSelectAll>
					<mat-option *ngFor="let loc of locations" [value]="loc.loccode">{{ loc.locationname }}</mat-option>
				  </mat-select>
				</mat-form-field>
			
				<!-- Export & Data Toggle -->
				<div class="d-flex justify-content-between mt-3">
				  <div>
					<button class="btn btn-sm btn-success" (click)="exportXls()" [disabled]="sending">
					  <i class="fa fa-file-excel-o"></i>
					</button>
					&nbsp;
					<button class="btn btn-sm btn-danger" (click)="exportPdf()" [disabled]="sending">
					  <i class="fa fa-file-pdf-o"></i>
					</button>
				  </div>
				  <button class="btn btn-sm btn-danger" (click)="toggleData()" *ngIf="!showdata">Show Data</button>
				</div>
			  </div>
			</div>
			

		</div>

	</div>
</div>
